import { isImage } from './Validations'

const IMAGE_TOTAL_DIMENSIONS_LIMIT = 10000 // For send message to channels
const IMAGE_RATIO_1_1 = Object.freeze({ ratio: 1 / 1, id: '1:1' })
const IMAGE_RATIO_9_16 = Object.freeze({ ratio: 9 / 16, id: '9:16' })

/**
 * Get Image information from a file
 * @param {File} file
 * @param {string} file.type
 *
 * @returns {Promise<{
 *  width: number,
 *  height: number
 * }>}
 */
export function getImgInfoFromFile(file) {
  return new Promise((resolve, reject) => {
    try {
      if (!file) return resolve(false)
      if (file.type && !isImage(file.type)) return resolve(false)

      const img = new Image()
      img.src = URL.createObjectURL(file)
      img.addEventListener("load", function() {
        resolve({
          width: this.naturalWidth || 0,
          height: this.naturalHeight || 0
        })
      })
    } catch(error) {
      reject(error)
    }
  })
}

/**
 * Check has image right dimensions
 * @param {File} file
 * @param {string} file.type
 * @param {object} params
 * @param {boolean} [params.isTotalDimensions10Kpx]
 * @param {object} [params.allowDimensions]
 * @param {'1:1'|'9:16'} params.allowDimensions.withRelation
 * @param {number} params.allowDimensions.width
 * @param {number} params.allowDimensions.height
 *
 * @returns {Promise<{
 *   isOk: boolean,
 *   message?: string
 * }>}
 */
export async function hasImgRightDimensions(file, params) {
  const { allowDimensions = {}, isTotalDimensions10Kpx = false } = params
  const response = { isOk: true }

  try {
    const withDimensions = Object.keys(allowDimensions).length > 0

    // No hay propiedades a validar se retorna true
    if (!withDimensions && !isTotalDimensions10Kpx) return response

    const imgInfo = await getImgInfoFromFile(file)

    // Cuando solo se necesita comprobar que el total no sea mayor a X
    if (!withDimensions && isTotalDimensions10Kpx) {
      const imgTotal = imgInfo.height + imgInfo.width

      if (imgTotal > IMAGE_TOTAL_DIMENSIONS_LIMIT) {
        return {
          isOk: false,
          message: 'dashboard_attachments_image-sum-10000'
        }
      }

      return response
    }

    const { width, height } = imgInfo
    const imgRatio = width / height

    // Dimension 9:16
    if (allowDimensions.withRelation === IMAGE_RATIO_9_16.id) {
      if (width < allowDimensions.width) return { isOk: false }
      if (height > allowDimensions.height) return { isOk: false }
      if (imgRatio !== IMAGE_RATIO_9_16.ratio) return { isOk: false }

      return response
    }

    // Dimension 1:1
    if (allowDimensions.withRelation === IMAGE_RATIO_1_1.id) {
      if (width > allowDimensions.width) return { isOk: false }
      if (height > allowDimensions.height) return { isOk: false }
      if (imgRatio !== IMAGE_RATIO_1_1.ratio) return { isOk: false }

      return response
    }

    if (width !== allowDimensions.width) return { isOk: false }
    if (height !== allowDimensions.height) return { isOk: false }

    return response
  } catch(error) {
    return {
      isOk: false,
      message: 'generic_error'
    }
  }
}